/**
 * @ngdoc service
 * @name Notifications
 *
 * @description
 * Used to store notifications data
 */

(function () {
  'use strict';
  app.service('notificationsService', ["apiService", function (apiService) {
    var _this = this;
    this.state = {
      data: [] // list of notifications
    };

    function sortNotifications(notifications) {
      return _.sortBy(notifications, function (notification) {
        return notification.timeString || notification.createTimeString;
      }).reverse();
    }

    this.actions = {
      fetchData: function (userId) {
        return apiService
          .getSome('notification/user/' + userId)
          .then(function (response) {
            _this.state.data = sortNotifications(response.data);
            return response;
          });
      },
      nextPageNotifications: function (userId) {
        var lastNotificationIndex = _this.state.data.length - 1;
        var latestNotificationId = _this.state.data.length ? _this.state.data[lastNotificationIndex].id : 0;
        return apiService
          .getSome('/notification/before/' + latestNotificationId + '/user/' + userId)
          .then(function (response) {
            return response;
          });
      },
      markReadNotifications: function (userId) {
        return apiService
          .updateSome('notification/user/' + userId + '/read')
          .then(function (response) {
            return response;
          });
      },
      toggleNotificationStatus: function (notificationId) {
        var notification = _.find(_this.state.data, { id: notificationId });
        var isRead = !notification.isRead;
        var action = isRead ? 'read' : 'unread';

        return apiService
          .updateSome('notification/' + notificationId + '/' + action, {})
          .then(function (response) {
            notification.isRead = isRead;
            return response;
          });
      },
      markRead: function (notificationId) {
        var notification = _.find(_this.state.data, { id: notificationId });
        if (notification.isRead) {
          return;
        }

        return apiService
          .updateSome('notification/' + notificationId + '/read', {})
          .then(function (response) {
            notification.isRead = true;
            return response;
          });
      },
      pullLatest: function (userId) {
        var latestNotificationId = _this.state.data.length ? _this.state.data[0].id : 0;
        return apiService
          .getSome('notification/after/' + latestNotificationId + '/user/' + userId)
          .then(function (response) {
            if (response.data.length) {
              var newNotifications = _this.state.data.concat(response.data);
              _this.state.data = sortNotifications(newNotifications);
            }
            return response;
          });
      }
    };
  }]);
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/notifications/service.js